/**
 * src/edit/src/utils/ajax/http.js
 *
 * Base Axios client for all HTTP requests for the Learn Backend.
 */

import axios, { AxiosRequestConfig } from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

export const client = axios.create({
  baseURL: BASE_URL,
} as AxiosRequestConfig)

export default client
